import { FilterTypeEnum } from '@creditsights/api-ui-web';
import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';
import { ROUTES } from '../../../../Base.constants';
import { SearchSuggestItem } from '../../../../models/SearchSuggest';
import { getTagPrefix, getTagSuffix } from '../../../../utils/tagUtils';

interface TagLinkParams {
  getRoute: (id: string) => string;
  tooltipText: string;
}

interface TagLinkDetails {
  route: string;
  tooltipText: string;
}

const TAG_LINKS: Record<string, TagLinkParams> = {
  company: {
    getRoute: (id) => ROUTES.company(id),
    tooltipText: 'Go to Company Page',
  },
  municipal: {
    getRoute: (id) => ROUTES.municipal(id),
    tooltipText: 'Go to Municipal Page',
  },
  analyst: {
    getRoute: (id) => ROUTES.analyst(id),
    tooltipText: 'Go to Analyst Bio',
  },
};

export const getTagDetailsLink = (tagId: string): TagLinkDetails | null => {
  const prefix = getTagPrefix(tagId);
  const suffix = getTagSuffix(tagId);

  const tagLinkParams = TAG_LINKS[prefix];
  if (!tagLinkParams) {
    return null;
  }

  return {
    route: tagLinkParams.getRoute(suffix),
    tooltipText: tagLinkParams.tooltipText,
  };
};

export const getSuggestType = (tagId: string, tagIdToFilterMap?: Record<string, FilterTypeEnum>): string => {
  const prefix = getTagPrefix(tagId);
  if (prefix === 'tag' || prefix === 'type-tag') {
    const type = tagIdToFilterMap?.[tagId];
    return type ? startCase(type) : '';
  }

  const prefixWords = tagId.substring(0, tagId.indexOf('/')).split('-');
  const capitalizedPrefixWords = prefixWords.map((prefix) => capitalize(prefix));
  return capitalizedPrefixWords.join(' ');
};

export const hasTagDetailsLinks = (searchSuggests: SearchSuggestItem[]): boolean =>
  searchSuggests.some((suggest) => TAG_LINKS[getTagPrefix(suggest.tagId)]);
